export default {
  DATE_ROW_COUNT: 6,
  DATE_COL_COUNT: 7
};


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-calendar/src/date/DateConstants.js
// module id = 343
// module chunks = 0